import React, {useState} from 'react'
import Select from "react-select";
import {Col, Row} from "reactstrap";

// components
import {ButtonCancel, CustomButton} from "../buttons/buttonsActions";

// labels
import {WHAT_WEEK_DAY, LB_ALL, CONTINUE} from "../i18n/i18n";

// providers
import {dateProvider} from "../../providers/utils/DateProvider";

const SelectWeekDay = props => {
    const {setExternalValue} = props

    const [selectedDays, setSelectedDays] = useState([])

    const onDayChange = day => setSelectedDays(day)

    const onSelectAll = () => setExternalValue([0], true)

    const onContinue = () => {
        const ids = selectedDays.map( day => day?.id)
        setExternalValue(ids)
    }
 
    return <>
        <h3>{WHAT_WEEK_DAY}</h3>

        <div style={{textAlign:'left',marginBottom:'1em'}}>
            <Row>
                <Col sm={{size:3, offset:4}}>
                    <Select
                        isMulti
                        defaultValue={ selectedDays }
                        options={ dateProvider.getWeekDays() }
                        isDisabled={ false }
                        isClearable={ false }
                        onChange={ onDayChange }
                        styles={{textAlign:'left' }}
                    />
                </Col>
                <Col sm={2}>
                    <CustomButton title={LB_ALL} onClick={onSelectAll}/>
                </Col>
            </Row>
        </div>

        <CustomButton title={CONTINUE} onClick={ onContinue} />
    </>
}

export default SelectWeekDay